import "./App.css"
import video from "./bbb.mp4"

function App() {
	return (
		<>
			<div className="App">
				<div className="video-background">
					<h1>
						tb-net.de
						<br />
						<span style={{ fontSize: "11px" }}>Wartungsmodus aktiv...</span>
						<br />
						<br />
						<p
							style={{
								marginTop: "0px",
								fontSize: "08px",
								fontWeight: "normal",
								letterSpacing: "1px",
							}}
						>
							Dipl.&nbsp;Inf.&nbsp;Thorsten&nbsp;Brüning
							<br />
							Varenholzstr.&nbsp;141&nbsp;&middot;&nbsp;44869&nbsp;Bochum
							<br />
							Handy/Fax:&nbsp;0176-56602-112
							<br />
							E-Mail:&nbsp;info@tb-net.de
							<br />
							<br />
						</p>
						<p
							style={{
								marginTop: "0px",
								fontSize: "08px",
								fontWeight: "normal",
								letterSpacing: "1px",
							}}
						>
							Bankverbindung: Herner Sparkasse
							<br />
							BIC: WELADED1HRN
							<br />
							IBAN: DE48 4325 0030 0157 5365 82
							<br />
							<br />
						</p>
						<p
							style={{
								marginTop: "0px",
								fontSize: "08px",
								fontWeight: "normal",
								letterSpacing: "1px",
							}}
						>
							Film:&nbsp;https://www.bigbuckbunny.org/
						</p>
					</h1>
				</div>
			</div>

			<video
				controls
				autoPlay
				muted
				loop
				playsInline
				webkit-playsinline="true"
				id="video-background"
			>
				<source src={video} type="video/mp4" />
			</video>
		</>
	)
}

export default App
